import type { MiniGameKind } from './mascot-game-types'
import styles from './MascotGame.module.css'

export function MiniGameArtwork({
  kind,
  sheep = false,
}: {
  kind: MiniGameKind
  sheep?: boolean
}) {
  return (
    <svg className={styles.gameIllustration} viewBox="0 0 240 150" aria-hidden="true">
      <ellipse cx="120" cy="132" rx="83" ry="9" fill="#263b38" opacity=".1" />
      {kind === 'frisbee' ? (
        <>
          <circle cx="190" cy="30" r="18" fill="#fff0ac" />
          <path d="M15 120Q65 68 115 109T225 99v36H15Z" fill="#75a885" />
          <path d="M15 134h210" stroke="#f7e9bc" strokeWidth="5" strokeLinecap="round" />
          <g className={styles.artFloat} transform="rotate(-12 151 54)">
            <ellipse cx="151" cy="57" rx="39" ry="12" fill="#d98145" />
            <ellipse cx="151" cy="51" rx="39" ry="12" fill="#ffce73" />
            <ellipse
              cx="151"
              cy="49"
              rx="26"
              ry="6"
              fill="none"
              stroke="#fff5c3"
              strokeWidth="3"
            />
            <path
              d="M97 49H68m28 11H80"
              stroke="#fff9dd"
              strokeWidth="4"
              strokeLinecap="round"
            />
          </g>
          <g fill="#fff8de" transform="rotate(-24 73 97)">
            <ellipse cx="72" cy="105" rx="15" ry="12" />
            <ellipse cx="54" cy="88" rx="6" ry="9" />
            <ellipse cx="71" cy="81" rx="6" ry="9" />
            <ellipse cx="87" cy="88" rx="6" ry="9" />
          </g>
          <path d="m166 132 4-21 15-6 13 10 3 17" fill="#849c91" />
        </>
      ) : kind === 'catch' ? (
        <>
          <path
            d="M31 36q11-21 26-4m136-4q12-12 21 5"
            stroke="#fff9df"
            strokeWidth="5"
            fill="none"
            strokeLinecap="round"
          />
          <g className={styles.artFloat}>
            {sheep ? (
              <g data-sheep-harvest-art>
                <path
                  d="M67 34q14-9 26 5L70 81q-4 7-6-1Z"
                  fill="#ed9b51"
                  stroke="#ba733d"
                  strokeWidth="2"
                />
                <path
                  d="m76 35-9-19m11 18 8-23m-6 23 20-11"
                  fill="none"
                  stroke="#73a65c"
                  strokeWidth="6"
                  strokeLinecap="round"
                />
                <path
                  d="m70 47 10 4m-12 9 7 3"
                  stroke="#f9d3a1"
                  strokeWidth="3"
                  strokeLinecap="round"
                />
              </g>
            ) : (
              <>
                <path
                  d="M84 36c-32-20-40 20-20 38 9 8 14 2 20 2s13 6 22-3c20-20 9-54-22-37Z"
                  fill="#ed775c"
                  stroke="#bf5548"
                  strokeWidth="2"
                />
                <path
                  d="M84 36q-3-15 7-21"
                  stroke="#6b653b"
                  strokeWidth="4"
                  fill="none"
                />
                <path d="M87 27q8-20 26-12-6 19-26 12" fill="#719953" />
                <path
                  d="M67 44q-8 7-5 15"
                  stroke="#ffd4b5"
                  strokeWidth="4"
                  strokeLinecap="round"
                  fill="none"
                />
              </>
            )}
          </g>
          <g className={styles.artFloatLate}>
            <path d="M155 37q-29 6-13 32l15 20 19-22q16-28-21-30" fill="#e6a742" />
            <path d="m144 38 10 7 12-9-11 1-5-8-1 10Z" fill="#6b9656" />
            <path
              d="m151 55 2 3m10-5 2 3m-8 9 2 3"
              stroke="#fff0bd"
              strokeWidth="3"
              strokeLinecap="round"
            />
          </g>
          <path
            d="M76 100h93l-10 31H86Z"
            fill="#b9814e"
            stroke="#81573c"
            strokeWidth="3"
          />
          <path
            d="M86 100q3-35 37-35t35 35"
            stroke="#81573c"
            strokeWidth="5"
            fill="none"
          />
          <path
            d="m97 105 3 22m22-22v22m23-22-3 22m-57-12h75"
            stroke="#e5bd7d"
            strokeWidth="4"
          />
        </>
      ) : kind === 'memory' ? (
        <>
          <g transform="rotate(-12 88 76)">
            <rect
              x="42"
              y="23"
              width="79"
              height="108"
              rx="15"
              fill="#8ba578"
              stroke="#fff9dc"
              strokeWidth="4"
            />
            <rect
              x="51"
              y="32"
              width="61"
              height="90"
              rx="10"
              fill="none"
              stroke="#d5e4b6"
              strokeDasharray="4 5"
              strokeWidth="2"
            />
            <path
              d="m82 53 7 16 18 4-14 12 2 18-13-10-15 10 3-18-14-12 19-4Z"
              fill="#e3edbe"
            />
          </g>
          <g className={styles.artFloat}>
            <g transform="rotate(10 150 76)">
              <rect
                x="113"
                y="21"
                width="79"
                height="108"
                rx="15"
                fill="#fff9dc"
                stroke="#a3b880"
                strokeWidth="3"
              />
              <path
                d="M153 106V66m0 25q-21-20-24-5 5 13 24 5"
                stroke="#6f9454"
                strokeWidth="5"
                fill="#9fbc74"
              />
              <g fill="#edc363">
                <ellipse cx="153" cy="48" rx="9" ry="15" />
                <ellipse cx="153" cy="78" rx="9" ry="15" />
                <ellipse cx="138" cy="63" rx="15" ry="9" />
                <ellipse cx="168" cy="63" rx="15" ry="9" />
              </g>
              <circle cx="153" cy="63" r="11" fill="#a27640" />
            </g>
          </g>
        </>
      ) : kind === 'runner' ? (
        <>
          <path d="M76 145 102 5h37l34 140" fill="#f2e5bb" />
          <path
            d="m121 15 2 15m2 15 2 17m3 17 4 20"
            stroke="#fffdf0"
            strokeWidth="4"
            strokeLinecap="round"
          />
          <path d="m48 86 10-21 22 4 10 20Z" fill="#8b9998" />
          <path d="m172 52 10-21 19 5 9 20Z" fill="#7e9390" />
          <g className={styles.artFloat}>
            <path
              d="M90 107q35 13 71-3"
              stroke="#7d6962"
              strokeWidth="12"
              strokeLinecap="round"
              fill="none"
            />
            <path
              d="M90 102q35 13 71-3"
              stroke="#b798b7"
              strokeWidth="8"
              strokeLinecap="round"
              fill="none"
            />
            <circle
              cx="103"
              cy="121"
              r="8"
              fill="#efc668"
              stroke="#866749"
              strokeWidth="3"
            />
            <circle
              cx="150"
              cy="119"
              r="8"
              fill="#efc668"
              stroke="#866749"
              strokeWidth="3"
            />
          </g>
          <path
            d="m51 112 19 2m-22 10 24 1m95-36 18-6"
            stroke="#f5fcf3"
            strokeWidth="4"
            strokeLinecap="round"
          />
          <path d="m153 20 3 7 8 1-6 5 1 8-6-4-7 3 2-8-5-5 8-1Z" fill="#eabe56" />
        </>
      ) : (
        <>
          <g transform="rotate(-7 120 80)">
            <rect x="58" y="23" width="125" height="112" rx="25" fill="#65546e" />
            <rect x="67" y="31" width="49" height="43" rx="12" fill="#9bb986" />
            <rect
              className={styles.artGlow}
              x="124"
              y="31"
              width="49"
              height="43"
              rx="12"
              fill="#ffe093"
            />
            <rect x="67" y="82" width="49" height="43" rx="12" fill="#e7a195" />
            <rect x="124" y="82" width="49" height="43" rx="12" fill="#a0cbd7" />
            <path
              d="m140 52 6 6 12-12"
              stroke="#a37c36"
              strokeWidth="4"
              strokeLinecap="round"
              fill="none"
            />
          </g>
          <g className={styles.artFloat} fill="#866c96">
            <path d="M195 37V15l17-4v21h-4V18l-9 2v17Z" />
            <ellipse cx="191" cy="38" rx="8" ry="5" />
            <ellipse cx="204" cy="32" rx="8" ry="5" />
          </g>
          <path d="m35 62 3 8 9 3-9 3-3 9-3-9-9-3 9-3Z" fill="#fff6cf" />
        </>
      )}
    </svg>
  )
}
